import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthHttpInterceptor } from '@auth0/auth0-angular';
import { Observable } from 'rxjs';

/**
 * Unlike the management-portal, this dashboard has no public GraphQL operations - every
 * request requires a session, so there is no allow-list of operation names to bypass here.
 */
@Injectable()
export class AuthInterceptor extends AuthHttpInterceptor {
  override intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return super.intercept(req, next);
  }
}
